<template>
  <transition
    @after-enter="afterEnter"
    @after-leave="afterLeave">
    <div v-if="visible || loading">
      <div :class="loading ? 'loading': 'message'" v-if="dialogType==='message'">
        <slot>
          <img src="../assets/img/loading.png" v-if="loading"/>
          <span v-else>{{ message }}</span>
        </slot>
      </div>
      <div v-else-if="dialogType==='alert'">
        <div class="bg-shadow"></div>
        <div class="dialog" :style="style">
          <div class="dialog-header">
            <slot name="title">
              <span class="dialog-title">{{ title }}</span>
            </slot>
            <button
                type="button"
                class="dialog-headerbtn"
                @click="handleClose">
            <span>关闭</span>
            </button>
          </div>
          <div class="dialog-body">{{ message }}</div>
          <div class="dialog-footer">
            <button type="button" class="btn-confirm" @click="handleClose">确定</button>
          </div>
        </div>
      </div>
      <div v-else-if="dialogType==='dialog'">
        <div class="bg-shadow"></div>
        <div class="dialog" :style="style">
          <div class="dialog-header">
            <slot name="title">
              <span class="dialog-title">{{ title }}</span>
            </slot>
            <button
                type="button"
                class="dialog-headerbtn"
                v-if="showClose"
                @click="handleClose">
            <span>关闭</span>
            </button>
          </div>
          <div class="dialog-body"><slot></slot></div>
          <div class="dialog-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'Dialog',
  props: {
    title: {
      type: String,
      default: '温馨提示'  
    },
    visible: {
      type: Boolean,
      default: false   
    },
    loading: {
      type: Boolean,
      default: false   
    },
    showClose: {
      type: Boolean,
      default: true 
    },
    width: String,
    dialogType: {
      type: String,
      default: 'message'  
    },
    message: {
      type: String,
      default: ''  
    },
    beforeClose: Function,
  },
  watch: {
    visible(val) {
      if (val) {
        this.closed = false;
        this.$emit('open');
        if (this.dialogType === 'message') {
            setTimeout(() => {
              this.handleClose()
            }, 2000)
        } 
      } else {
        if (!this.closed) this.$emit('close');
      }
    },
    loading(val) {
      if (val) {
        this.closed = false;
        this.$emit('open');
      } else {
        if (!this.closed) this.$emit('close');
      }
    }
  },
  computed: {
    style() {
      let style = {};
      if (this.width) {
        style.width = this.width;
      }
      return style;
    }
  },
  methods: {
    handleClose() {
      if (typeof this.beforeClose === 'function') {
        this.hide().then(() => {
          this.beforeClose()
        })
      } else {
        this.hide()
      }
    },
    async hide(cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false);
        this.$emit('update:loading', false);
        this.$emit('close');
        this.closed = true;
      }
    },
    afterEnter() {
      this.$emit('opened');
    },
    afterLeave() {
      this.$emit('closed');
    }  
  }
}
</script>
<style scoped>
.bg-shadow{
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  background-color: #3c3c3e;
  z-index:1000;
  -moz-opacity: 0.8;
  opacity:.80;
  filter: alpha(opacity=88);
}
.dialog{   
  z-index: 1001;
  background-color: #ffffff;
  position: fixed;
  left: 50%;
  top: 50%;
  width: 35%;
  border-radius: 1px;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);	/* IE 9 */
  -moz-transform: translate(-50%, -50%);	/* Firefox */
  -webkit-transform: translate(-50%, -50%);/* Safari 和 Chrome */
  -o-transform: translate(-50%, -50%); 	/* Opera */
}
.dialog-header{
  background-color: #199ED8;
  color: #fff;
  padding: 15px 20px;
}
.dialog-header .title{
  float: left;
}
.dialog-header .dialog-headerbtn{
  float: right;
  background: rgba(255,255,255,0);
  color: #fff;
  cursor: pointer;
}
.dialog-body{
  margin: 30px;
}
.message,.loading{
  color: #fff;
  position: absolute;
  left: 0;
  top: 0;
  left: 50%;
  top: 50%;
  text-align: center;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);	/* IE 9 */
  -moz-transform: translate(-50%, -50%);	/* Firefox */
  -webkit-transform: translate(-50%, -50%);/* Safari 和 Chrome */
  -o-transform: translate(-50%, -50%); 	/* Opera */
}
.message{ 
  padding: 15px 50px;
  background-color: rgba(0, 0, 0, 0.6);
}
.dialog-footer{
  text-align: center;
}
.dialog-footer .btn-confirm{
  border-radius: 4px;
  background: #199ED8;
  color: #FFFFFF;
  padding: 10px 30px;
  font-size: 15px;
  line-height: 1.3333333;
  margin-bottom: 40px;
  cursor: pointer;
}
.loading{ 
  padding: 15px 20px;
  background-color: rgba(0, 0, 0, 0.4);
}
.loading img{
  width: 20px;
  animation: load 0.55s linear infinite;
  -webkit-animation: load 0.55s linear infinite;
}
@-webkit-keyframes load{
  25%{
   transform: rotate(90deg);
   -moz-transform:rotate(90deg);
   -webkit-transform:rotate(90deg);
  }
  50%{
   transform: rotate(180deg);
   -moz-transform:rotate(180deg);
   -webkit-transform:rotate(180deg);
  }
  75%{
   transform: rotate(270deg);
   -moz-transform:rotate(270deg);
   -webkit-transform:rotate(270deg);
  }
  100%{
   transform: rotate(360deg);
   -moz-transform:rotate(360deg);
   -webkit-transform:rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog.vue